export const outbrain = (partnersIds) => {
  Object.entries(partnersIds).forEach(([partnerId, partnerOptions]) => {
    !(function (_window, _document) {
      if (_window.obApi) {
        const toArray = function (object) {
          return Object.prototype.toString.call(object) === '[object Array]' ? object : [object]
        }
        _window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(partnerId))
        return
      }

      var api = (_window.obApi = function () {
        api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments)
      })

      api.version = '1.1'
      api.loaded = true
      api.marketerId = partnerId
      api.queue = []
      const tag = _document.createElement('script')
      tag.async = true
      tag.src = '//amplify.outbrain.com/cp/obtp.js'
      tag.type = 'text/javascript'

      const script = _document.getElementsByTagName('script')[0]
      script.parentNode.insertBefore(tag, script)
    })(window, document)

    if ('events' in partnerOptions) {
      callEvents(partnerOptions.events)
    }
  })

  function callEvents(tracks) {
    Object.entries(tracks).forEach(([index, track]) => {
      if (track.type == 'purchase') {
        callPurchaseEvent(track.params)
      }

      if (track.type == 'checkout') {
        return obApi(
          'track',
          track.params.event_name !== undefined && track.params.event_name != ''
            ? track.params.event_name
            : 'PAGE_VIEW'
        )
      }
    })
  }

  function callPurchaseEvent(params) {
    if (params.ob_event_name !== undefined && params.ob_event_name != '') {
      return obApi('track', params.ob_event_name, {
        orderValue: params.value,
        currency: params.currency,
      })
    }

    return obApi('track', 'PAGE_VIEW')
  }
}
